import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useLocalization } from '@shared-ui/localization-context';
import { Viewport, ViewSmall, ViewLarge } from '@shared-ui/viewport-context';
import * as React from 'react';
import '../../input/input/index.esm.js';
import '../../input/faux-input/index.esm.js';
import { EGDSTextInput } from '../../input/text-input/index.esm.js';
import '../../input/password-input/index.esm.js';
import '../../input/informative-input/index.esm.js';
import '../../input/textarea/index.esm.js';
import '../../input/chat-textarea/index.esm.js';
import { EGDSFakeInput } from '../../input/fake-input/index.esm.js';
import '../../input/card-number-input/index.esm.js';
import '../../input/select/index.esm.js';
import '../../input/swapper-input/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSTypeaheadDialog } from '../typeahead-dialog/index.esm.js';
import { EGDSTypeaheadInput } from '../typeahead-input/index.esm.js';
import { EGDSTypeaheadMenu } from '../typeahead-menu/index.esm.js';
import { EGDSTypeaheadSelections } from '../typeahead-selections/index.esm.js';
import styles from '../../styles/uitk-egds-typeahead.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { isElementVisible } from '../../utils/is-element-visible/index.esm.js';
import { liveAnnounce } from '../../utils/live-announce/index.esm.js';
import { analyticsTracker } from '../../utils/analytics-tracker/index.esm.js';
const getClassNameList = classNames.bind(styles);
const l10nStrings = {
  enteringInput: 'typeahead.enteringInput'
};
var TypeaheadRenderType;
(function (TypeaheadRenderType) {
  TypeaheadRenderType["MENU"] = "menu";
  TypeaheadRenderType["DIALOG"] = "dialog";
  TypeaheadRenderType["ADAPTIVE"] = "adaptive";
})(TypeaheadRenderType || (TypeaheadRenderType = {}));
class Typeahead extends React.Component {
  static displayName = 'EGDSTypeahead';
  static defaultProps = {
    hasClearButton: false,
    onInputChange: () => null,
    renderType: TypeaheadRenderType.ADAPTIVE,
    isMulti: false
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.isMulti) {
      return {
        ...prevState,
        searchTerm: ''
      };
    }
    if (nextProps.value !== prevState.searchTerm) {
      return {
        ...prevState,
        searchTerm: nextProps.value ?? ''
      };
    }
    return null;
  }
  keyArray = [];
  typeaheadInputRef;
  constructor(props) {
    super(props);
    this.state = {
      dialog: false,
      mounted: false,
      searchTerm: '',
      startSearchTerm: '',
      cachedSearchTerm: ''
    };
    if (props.isMulti && !Array.isArray(props.value)) {
      console.warn('Use an array of values if set to isMulti');
    }
    this.typeaheadInputRef = React.createRef();
    this.handleResultItemSelect = this.handleResultItemSelect.bind(this);
    this.dismissTypeahead = this.dismissTypeahead.bind(this);
    this.openTypeahead = this.openTypeahead.bind(this);
    this.renderDialog = this.renderDialog.bind(this);
    this.renderMenu = this.renderMenu.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.focusTypeaheadInput = this.focusTypeaheadInput.bind(this);
    this.renderMenuTypeahead = this.renderMenuTypeahead.bind(this);
    this.renderDialogTypeahead = this.renderDialogTypeahead.bind(this);
    this.updateStartSearchTerm = this.updateStartSearchTerm.bind(this);
    this.updateCachedSearchTerm = this.updateCachedSearchTerm.bind(this);
  }
  componentDidMount() {
    const {
      value,
      onMountCB,
      isMulti
    } = this.props;
    if (Array.isArray(value) && isMulti) {
      this.setState({
        searchTerm: value.join(', ')
      });
    }
    this.setState({
      mounted: true
    });
    if (onMountCB) {
      onMountCB(this.typeaheadInputRef);
    }
  }
  handleKeyPress(e, triggerType) {
    const code = e.keyCode || e.which;
    const keyValue = e.key;
    if (code >= 65 && code <= 90 || code >= 97 && code <= 122) {
      this.keyArray.push(keyValue);
      const joinedKeyArray = this.keyArray.join('');
      if (triggerType === TypeaheadRenderType.DIALOG) {
        this.updateStartSearchTerm(triggerType, joinedKeyArray);
      }
    }
  }
  handleClear() {
    const {
      handleClear
    } = this.props;
    this.setState({
      searchTerm: ''
    });
    if (typeof handleClear === 'function') {
      handleClear();
    }
  }
  handleResultItemSelect(term, data) {
    const {
      onUpdate,
      isMulti,
      onResultSelection,
      id
    } = this.props;
    if (onUpdate) {
      onUpdate({
        term,
        data
      });
    }
    if (onResultSelection) {
      const event = new CustomEvent('change');
      const input = document.createElement('input');
      input.value = term;
      if (data && data.id || id) {
        input.setAttribute('id', data.id ?? id);
      }
      input.addEventListener('change', inputEvent => {
        onResultSelection(inputEvent);
      });
      input.dispatchEvent(event);
    }
    if (!isMulti) {
      this.setState({
        searchTerm: term
      });
      this.focusTypeaheadInput();
    }
  }
  getAdapter() {
    const {
      adapter,
      l10n
    } = this.props;
    // Check if the adapter has a `setL10n` method and call it
    if (typeof adapter.setL10n === 'function') {
      adapter.setL10n(l10n);
    }
    return adapter;
  }
  dismissTypeahead(triggerType) {
    const {
      onDismiss
    } = this.props;
    const isVisible = isElementVisible(this.typeaheadInputRef.current);
    if (typeof onDismiss === 'function') {
      onDismiss(triggerType);
    }
    this.setState({
      dialog: false,
      startSearchTerm: ''
    });
    this.keyArray = [];
    if (this.typeaheadInputRef.current && isVisible) {
      this.typeaheadInputRef.current.focus();
    }
  }
  updateStartSearchTerm(triggerType, keyValue) {
    this.setState({
      startSearchTerm: keyValue
    }, () => {
      if (triggerType === 'dialog') {
        this.openTypeahead(triggerType);
      }
    });
  }
  openTypeahead(triggerType) {
    const {
      adapter,
      onClick
    } = this.props;
    const {
      dialog,
      searchTerm
    } = this.state;
    const previousState = dialog;
    // To handle menu open/close
    if (triggerType === TypeaheadRenderType.MENU) {
      if (previousState) {
        this.dismissTypeahead(triggerType);
      } else {
        if (typeof onClick === 'function') {
          onClick(triggerType);
        }
        this.setState({
          dialog: true
        });
        setTimeout(() => {
          adapter.typeaheadDialogOpened(searchTerm);
        });
      }
    }
    // To handle dialog open/close
    else if (triggerType === TypeaheadRenderType.DIALOG) {
      if (typeof onClick === 'function') {
        onClick(triggerType);
      }
      this.setState({
        dialog: true
      });
    }
  }
  focusTypeaheadInput() {
    const {
      l10n,
      enteringInputAnnounce
    } = this.props;
    liveAnnounce(enteringInputAnnounce ?? l10n.formatText(l10nStrings.enteringInput));
    if (this.typeaheadInputRef.current) {
      this.typeaheadInputRef.current.focus();
    }
  }
  updateCachedSearchTerm(e) {
    this.setState({
      cachedSearchTerm: e.target.value
    });
  }
  filterLayoutPositionClassName(className, include) {
    return className?.split(' ').filter(c => c.startsWith('uitk-layout-position') === include);
  }
  renderMenu() {
    const {
      allowExactMatch,
      label,
      listTitle,
      categorize,
      onInputChange,
      stid,
      typeaheadPlaceholder,
      typeaheadEmptyResultPlaceholder,
      value,
      isMulti = false,
      customTrigger,
      dismissButtonText,
      clearAllText,
      handleClear,
      onItemRemove,
      selectedItemHeading,
      l10n,
      defaultTerm,
      debounceRate,
      required,
      showingResults,
      itemSelected,
      menuClosed,
      trigerLabel,
      resultsAvailable,
      showingResultsDefault,
      multiSelectDismiss
    } = this.props;
    const additionalProps = {
      onDismiss: () => {
        this.dismissTypeahead('menu');
      }
    };
    const {
      dialog,
      searchTerm,
      cachedSearchTerm
    } = this.state;
    const adapter = this.getAdapter();
    if (categorize) {
      adapter.setTypeaheadCategories();
    }
    return jsx(EGDSTypeaheadMenu, {
      ...additionalProps,
      isMulti: isMulti,
      value: value,
      label: label,
      adapter: adapter,
      dialog: customTrigger && customTrigger.showTypeahead || dialog,
      allowExactMatch: allowExactMatch,
      onInputChange: onInputChange,
      onResultItemSelect: this.handleResultItemSelect,
      stid: stid,
      term: (searchTerm || cachedSearchTerm) ?? defaultTerm,
      placeholder: typeaheadPlaceholder,
      emptyResultPlaceholder: typeaheadEmptyResultPlaceholder,
      listTitle: listTitle,
      categorize: categorize,
      handleClear: this.handleClear,
      clearAllText: clearAllText,
      onClearAll: handleClear,
      dismissButtonText: multiSelectDismiss ?? dismissButtonText ?? l10n.formatText('typeahead.multiselect.dismiss'),
      onItemRemove: onItemRemove,
      selectedItemHeading: selectedItemHeading,
      defaultTerm: defaultTerm,
      debounceRate: debounceRate,
      typeaheadInputRef: this.typeaheadInputRef,
      historyDetail: adapter.isHistoryDetailEnabled(),
      required: required,
      updateCachedSearchTerm: this.updateCachedSearchTerm,
      showingResults: showingResults,
      itemSelected: itemSelected,
      menuClosed: menuClosed,
      trigerLabel: trigerLabel,
      resultsAvailable: resultsAvailable,
      showingResultsDefault: showingResultsDefault
    });
  }
  renderDialog() {
    const {
      allowExactMatch,
      id,
      label,
      listTitle,
      categorize,
      onInputChange,
      stid,
      typeaheadPlaceholder,
      typeaheadEmptyResultPlaceholder,
      customTrigger,
      defaultTerm,
      isMulti = false,
      clearAllText,
      handleClear,
      dismissButtonText,
      selectedItemHeading,
      onItemRemove,
      value,
      l10n,
      debounceRate,
      strictFullscreen,
      required,
      menuClosed,
      itemSelected,
      showingResults,
      resultsAvailable,
      showingResultsDefault
    } = this.props;
    const {
      dialog,
      searchTerm,
      startSearchTerm,
      cachedSearchTerm
    } = this.state;
    const adapter = this.getAdapter();
    if (categorize) {
      adapter.setTypeaheadCategories();
    }
    const additionalProps = {
      onDismiss: () => {
        this.dismissTypeahead(TypeaheadRenderType.DIALOG);
      }
    };
    return jsx(EGDSTypeaheadDialog, {
      adapter: adapter,
      allowExactMatch: allowExactMatch,
      dialog: customTrigger && customTrigger.showTypeahead || dialog,
      id: id,
      label: label,
      ...additionalProps,
      onInputChange: onInputChange,
      onResultItemSelect: this.handleResultItemSelect,
      term: searchTerm || cachedSearchTerm,
      startSearchTerm: startSearchTerm,
      stid: stid,
      placeholder: typeaheadPlaceholder,
      emptyResultPlaceholder: typeaheadEmptyResultPlaceholder,
      listTitle: listTitle,
      categorize: categorize,
      handleClear: this.handleClear,
      defaultTerm: defaultTerm,
      isMulti: isMulti,
      clearAllText: clearAllText,
      onClearAll: handleClear,
      dismissButtonText: dismissButtonText ?? l10n.formatText('typeahead.multiselect.dismiss'),
      onItemRemove: onItemRemove,
      selectedItemHeading: selectedItemHeading,
      value: value,
      debounceRate: debounceRate,
      strictFullscreen: strictFullscreen,
      typeaheadInputRef: this.typeaheadInputRef,
      historyDetail: adapter.isHistoryDetailEnabled(),
      required: required,
      updateCachedSearchTerm: this.updateCachedSearchTerm,
      menuClosed: menuClosed,
      itemSelected: itemSelected,
      showingResults: showingResults,
      resultsAvailable: resultsAvailable,
      showingResultsDefault: showingResultsDefault
    });
  }
  renderTrigger(triggerType) {
    const {
      accessibilityLabel,
      analytics,
      icon,
      hasClearButton,
      hasVisibleLabel,
      invalid,
      label,
      name,
      placeholder,
      stid,
      customTrigger,
      children,
      isMulti,
      value,
      required,
      className,
      triggerComponentWidth
    } = this.props;
    const {
      mounted,
      searchTerm,
      dialog
    } = this.state;
    const a11yLabel = accessibilityLabel || label;
    const TriggerTag = triggerType === 'menu' ? EGDSTextInput : EGDSTypeaheadInput;
    const layoutPositionClassName = this.filterLayoutPositionClassName(className, true)?.join(' ');
    if (customTrigger) {
      return children;
    }
    const triggerCompStyle = {
      ...(triggerComponentWidth && {
        width: triggerComponentWidth
      })
    };
    return jsxs("div", {
      className: layoutPositionClassName,
      "data-stid": "typeahead-trigger",
      style: triggerCompStyle,
      children: [mounted && jsx(EGDSFakeInput, {
        "aria-label": [a11yLabel, searchTerm].filter(str => str && str.length > 0).join(' '),
        "aria-expanded": dialog,
        icon: icon,
        label: label,
        hasClearButton: hasClearButton,
        handleClear: this.handleClear,
        "aria-describedby": invalid && stid ? `${stid}-input-error` : undefined,
        "data-stid": stid && triggerType === TypeaheadRenderType.MENU ? `${stid}-menu-trigger` : stid && triggerType === 'dialog' ? `${stid}-dialog-trigger` : '',
        domRef: this.typeaheadInputRef,
        onClick: () => {
          this.openTypeahead(triggerType);
        },
        onKeyPress: e => {
          this.handleKeyPress(e, triggerType);
        },
        onClickCapture: analytics && analyticsTracker.bind(this, analytics, ''),
        placeholder: placeholder,
        value: isMulti && Array.isArray(value) ? value.join(', ') : value,
        invalid: invalid,
        required: required,
        clearButtonLabel: searchTerm
      }), jsx(TriggerTag, {
        className: getClassNameList({
          'is-hidden': mounted
        }),
        icon: icon,
        label: label,
        "data-stid": stid && `${stid}-input`,
        domRef: this.typeaheadInputRef,
        hasClearButton: false,
        hasVisibleLabel: hasVisibleLabel,
        name: name,
        onChange: Typeahead.defaultProps.onInputChange,
        placeholder: placeholder,
        value: searchTerm,
        id: stid && `${stid}-input`,
        required: required,
        clearButtonLabel: searchTerm
      })]
    });
  }
  renderMenuTypeahead() {
    const {
      renderMenu,
      customTrigger
    } = this.props;
    const {
      dialog
    } = this.state;
    const showTypeahead = customTrigger && customTrigger.showTypeahead || dialog;
    return renderMenu ? renderMenu(this.renderMenu()) : jsxs(Fragment, {
      children: [jsx("div", {
        className: getClassNameList('uitk-typeahead-menu-layer', {
          'uitk-typeahead-menu-layer-responsive': showTypeahead,
          'is-hidden': !showTypeahead
        }),
        children: this.renderMenu()
      }), this.renderTrigger(TypeaheadRenderType.MENU)]
    });
  }
  renderDialogTypeahead() {
    const {
      renderDialog,
      customTrigger
    } = this.props;
    const {
      dialog
    } = this.state;
    const showTypeahead = customTrigger && customTrigger.showTypeahead || dialog;
    return jsxs(Fragment, {
      children: [renderDialog ? dialog ? renderDialog(this.renderDialog()) : null : jsx("div", {
        className: getClassNameList('uitk-typeahead-dialog-layer', {
          'uitk-typeahead-dialog-layer-responsive': showTypeahead,
          'is-hidden': !showTypeahead
        }),
        children: this.renderDialog()
      }), this.renderTrigger(TypeaheadRenderType.DIALOG)]
    });
  }
  render() {
    const {
      renderType,
      stid,
      isMulti,
      value,
      onItemRemove,
      multiSelectClearAll,
      multiSelectSelectedItemHeading,
      clearAllText,
      showPills,
      label,
      className,
      removeSelection,
      clearAllSelections
    } = this.props;
    const otherClassNames = this.filterLayoutPositionClassName(className, false) || [];
    const finalClassName = [getClassNameList('uitk-typeahead')?.split(' '), ...otherClassNames].join(' ');
    return jsxs("div", {
      className: finalClassName,
      "data-stid": stid,
      children: [renderType === TypeaheadRenderType.DIALOG ? this.renderDialogTypeahead() : renderType === TypeaheadRenderType.MENU ? this.renderMenuTypeahead() : renderType === TypeaheadRenderType.ADAPTIVE ? jsxs(Viewport, {
        children: [jsx(ViewSmall, {
          children: this.renderDialogTypeahead()
        }), jsx(ViewLarge, {
          children: this.renderMenuTypeahead()
        })]
      }) : '', isMulti && showPills ? jsx(EGDSTypeaheadSelections, {
        typeaheadLabel: label,
        hideHeading: true,
        values: value,
        stid: stid,
        onItemRemove: onItemRemove,
        onClear: this.handleClear,
        clearAllText: clearAllText,
        className: getClassNameList('uitk-spacing-margin-blockstart-three'),
        multiSelectClearAll: multiSelectClearAll,
        multiSelectSelectedItemHeading: multiSelectSelectedItemHeading,
        removeSelection: removeSelection,
        clearAllSelections: clearAllSelections
      }) : null]
    });
  }
}
const EGDSTypeahead = React.forwardRef((props, ref) => {
  const l10n = useLocalization();
  return jsx(Typeahead, {
    l10n: l10n,
    ref: ref,
    ...props
  });
});
export { EGDSTypeahead, TypeaheadRenderType };